export const gallerySlides = [
  {
    original: './gallery/open-ceremony-26-27.jpg',
    eyebrowKey: 'gallery-eyebrow-2',
    titleKey: 'event-title-24',
    descriptionKey: 'gallery-description-4',
    buttonLabelKey: 'read-more',
    imagePosition: 'center 55%',
    mobileImagePosition: 'center 55%',
    to: 'https://mp.weixin.qq.com/s/fsujlVmAPFQIznNPt2Vd2Q',
    isExternal: true,
  },
  {
    original: './gallery/gallery-1.jpg',
    eyebrowKey: 'gallery-eyebrow-1',
    titleKey: 'school',
    descriptionKey: 'gallery-description-1',
    to: '/about-history',
    isExternal: false,
  },
  {
    original: './gallery/gallery-2.jpg',
    eyebrowKey: 'gallery-eyebrow-2',
    titleKey: 'see-events',
    descriptionKey: 'gallery-description-2',
    to: '/events',
    isExternal: false,
  },
  {
    original: './gallery/gallery-3.jpg',
    eyebrowKey: 'gallery-eyebrow-3',
    titleKey: 'staff',
    descriptionKey: 'gallery-description-3',
    imagePosition: 'center 58%',
    to: '/about-faculty-and-staff',
    isExternal: false,
  },
];
